import { render, staticRenderFns } from "./dataPage.vue?vue&type=template&id=5643bee7&scoped=true"
import script from "./dataPage.vue?vue&type=script&lang=js"
export * from "./dataPage.vue?vue&type=script&lang=js"
import style0 from "./dataPage.vue?vue&type=style&index=0&id=5643bee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643bee7",
  null
  
)

export default component.exports